import {MESSAGE_WRITER_INPUT_CHANGED, MESSAGE_WRITER_SET_FIELD} from "./message-writer-constants";

export function messageWriterSetField(messageId, field, payload) {
  return {type: MESSAGE_WRITER_SET_FIELD, messageId, field, payload};
}

export function messageWriterInputChanged(messageId, field, payload) {
  return {type: MESSAGE_WRITER_INPUT_CHANGED, messageId, field, payload};
}
